import React, { useState, useContext } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import styled from "styled-components";
// components
import BenefitForm from "./BenefitForm";
// entity
import { LocalBenefitForm } from "../../../../../models/domain";
// services
import { validateHrLocalBenefitCreate } from "../../../../../services/validations/hr/hrLocalBenefitValidation";
import * as actionCreators from "../../../../../actions/hr/localBenefits.actions";
import * as localBenefitsService from "../../../../../services/api/hr/localBenefits.service";
// context
import { useTranslation } from "react-i18next";

const EditBenefitStyles = styled.div`
  .title {
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4b4b4b;
    margin: 30px 0;
  }

  .form {
    width: 481px;
    height: calc(100vh - 120px);
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

const EditBenefit = ({
  closeModal,
  chosenBenefitGroupId,
  chosenBenefitId,
  localBenefitGroups,
  editLocalBenefit,
  refetchData
}) => {
  const { t } = useTranslation();

  const handleUpdateLocalBenefitError = ({ error }) => {
    const { data } = error;
    if (data) {
      if (data.errors && data.error) {
        if (data.errors.restrict) {
          toast.error(
            `${t(data.error.message)}: ${t(data.errors.restrict.keys[0])}`
          );
        }
        if (data.errors.title) {
          toast.error(
            `${t(data.error.message)}: ${t(data.errors.title.keys[0])}`
          );
        }
        if (data.errors.photo) {
          toast.error(
            `${t(data.error.message)}: ${t(data.errors.photo.keys[0])}`
          );
        }
        if (data.errors.expiration) {
          toast.error(
            `${t(data.error.message)}: ${t(data.errors.expiration.keys[0])}`
          );
        }
        if (data.errors.tokenPrice) {
          toast.error(
            `${t(data.error.message)}: ${t(data.errors.tokenPrice.keys[0])}`
          );
        }
        if (data.errors.description) {
          toast.error(
            `${t(data.error.message)}: ${t(data.errors.description.keys[0])}`
          );
        }
        if (data.errors.summary) {
          toast.error(
            `${t(data.error.message)}: ${t(data.errors.summary.keys[0])}`
          );
        }
        if (data.errors.benefitGroupId) {
          toast.error(
            `${t(data.error.message)}: ${t(data.errors.benefitGroupId.keys[0])}`
          );
        }
      } else {
        toast.error(t(data.error.message));
      }
    } else {
      toast.error("Something went wrong!");
    }
  };

  const updateBenfit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    const response = await localBenefitsService.editLocalBenefit(
      values,
      chosenBenefitId,
      chosenBenefitGroupId
    );

    setSubmitting(false);

    if (response.hasError) {
      return handleUpdateLocalBenefitError(response);
    }

    editLocalBenefit(chosenBenefitGroupId, response);
    refetchData();
    toast.success(t("success_edit_benefit"));
    closeModal();
  };

  const formik = useFormik({
    initialValues:
      localBenefitGroups
        .find(benefitGroup => benefitGroup.id === chosenBenefitGroupId)
        .benefits.find(benefit => benefit.id === chosenBenefitId) ||
      new LocalBenefitForm(),
    validate: validateHrLocalBenefitCreate,
    onSubmit: updateBenfit
  });

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    handleChange,
    handleBlur
  } = formik;

  return (
    <EditBenefitStyles>
      <h3 className="title">{t("edit_local_benefit")}</h3>
      <form className="form" autoComplete="off" onSubmit={handleSubmit}>
        <BenefitForm
          buttonText="Update"
          values={values}
          errors={errors}
          touched={touched}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          setFieldError={setFieldError}
          handleChange={handleChange}
          handleBlur={handleBlur}
          disableButton={isSubmitting}
          closeModal={closeModal}
          isEdit
        />
      </form>
    </EditBenefitStyles>
  );
};

EditBenefit.propTypes = {
  chosenBenefitGroupId: PropTypes.number,
  chosenBenefitId: PropTypes.number,
  closeModal: PropTypes.func
};

const mapStateToProps = state => {
  return {
    localBenefitGroups: state.localBenefits.localBenefitGroups
  };
};

const mapDispatchToProps = dispatch => {
  return {
    editLocalBenefit: (benefitGroupId, benefit) =>
      dispatch(actionCreators.editLocalBenefit(benefitGroupId, benefit))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditBenefit);
